import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Header from './components/Header';
import Home from './components/Home'; // Asegúrate de que la ruta sea correcta
import Contact from './pages/ContactPage'; // Asegúrate de que la ruta sea correcta
import About from './pages/AboutPage'; // Asegúrate de que la ruta sea correcta
import Blog from './pages/BlogPage'; // Asegúrate de que la ruta sea correcta
import Services from './pages/ServicesPage'; // Asegúrate de que la ruta sea correcta
import Footer from './components/Footer'; // Asegúrate de
import HomePage from './pages/HomePage'
function Apps() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default Apps;